import React from "react";
import { ScanFaceIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { images } from "../data/offer";
export function Hero() {
  return <header className="bg-cream px-4 pb-14 pt-6 sm:px-6 md:pb-20 md:pt-10" data-id="element-177" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-5xl text-center" data-id="element-178" data-mp="4lyuukqi8cd4">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-179" data-mp="4n9wof0e3a1l">
          <span className="inline-flex items-center gap-2" data-id="element-180" data-mp="128fs5pz8mpyv">
            <span className="grid h-9 w-9 place-items-center rounded-lg bg-navy text-gold-light" data-id="element-181" data-mp="xae5yw6imaj6">
              <ScanFaceIcon className="h-5 w-5" aria-hidden="true" data-id="element-182" data-mp="sbb5lp1hcshj" />
            </span>
            <span className="font-serif text-xl font-bold text-navy" data-id="element-183" data-mp="sd4bv386lap0">Facelift Blueprint™</span>
          </span>
          <span className="rounded-full border border-line bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-gold-dark" data-id="element-184" data-mp="3d1ii934hv0k9">
            By Dr. Michael Carter
          </span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl font-serif text-[2.35rem] font-bold leading-[1.06] text-ink sm:text-5xl md:text-[4rem]" data-id="element-185" data-mp="3j8sfs1yzrlqd">
          Review a Facelift Case in <em className="text-gold-dark" data-id="element-186" data-mp="3o6u5h5qxajat">15 Minutes</em>
        </h1>
        <p className="mt-3 font-serif text-xl italic text-navy sm:text-2xl" data-id="element-187" data-mp="399bcfr77pjxk">— With a Structured Educational Framework</p>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-188" data-mp="3e7l5nw9dmagj">
          A structured professional learning system designed to help plastic surgeons organize their facelift case reviews — from
          patient assessment and preoperative considerations to procedural concepts, case-based learning, and postoperative review.
        </p>

        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-ink sm:text-lg" data-id="element-189" data-mp="2vjzqupgsee59">
          <strong data-id="element-190" data-mp="2hix1o3uhwnq4">6 Premium Volumes</strong>. <strong data-id="element-191" data-mp="2hjyof5kviyno">5 Professional Bonuses</strong>. <strong data-id="element-192" data-mp="2lkike5tpnw88">30+ Educational Tools</strong>,
          Worksheets, and Case-Review Resources.
        </p>

        <img src={images.hero} alt="Facelift Blueprint™ — six premium volumes, professional tools, worksheets and digital devices" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-193" data-mp="s2jnvz2aw4kk" />

        <p className="mx-auto mb-6 max-w-xl text-[15px] font-medium leading-relaxed text-navy sm:text-base" data-id="element-194" data-mp="id9umfvq0fuv">
          Stop jumping between scattered notes, lectures, and surgical references. Start organizing your facelift education with one
          repeatable framework.
        </p>

        <CTAButton id="hero-cta" label="I want the Facelift Blueprint™" note="Instant digital access · One-time payment of $27 USD · Lifetime access · 7-day money-back guarantee" data-id="element-195" data-mp="161aul0eu2nyo" />

        <Countdown data-id="element-196" data-mp="x033b2aqine3" />
      </div>
    </header>;
}